<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">安全设置</h3>
        <div class="set-wrap">
          <div class="line flex">
            <div class="left">
              <p class="tit">登录密码</p>
              <p class="tips">经常更改密码有助于保护您的帐号安全</p>
            </div>
            <el-button type="primary" size="small" @click="dialogVisible = true">修改</el-button>
          </div>
          <!-- <div class="line flex">
            <div class="left phone">
              <p class="tit">
                手机号
                <span>131****8186已绑定</span>
              </p>
              <p class="tips">请用您常用的手机号为绑定手机号</p>
            </div>
            <el-button type="primary" size="small" @click="updatePhone">更换</el-button>
          </div>-->
        </div>
      </div>
      <!-- 修改密码弹框 -->
      <el-dialog
        title="修改密码"
        :visible.sync="dialogVisible"
        width="30%"
        @close="resetForm('ruleForm')"
      >
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
          <el-form-item label="旧密码：" prop="oldPass">
            <el-input
              type="password"
              v-model="ruleForm.oldPass"
              placeholder="请输入旧密码"
              autocomplete="off"
              show-password
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              placeholder="请输入新密码"
              autocomplete="off"
              show-password
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="checkPass">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              placeholder="请输入确认密码"
              autocomplete="off"
              show-password
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item class="bot">
            <el-button type="primary" @click="onSubmit('ruleForm')" size="small">确认</el-button>
            <el-button @click="dialogVisible = false" size="small">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 修改手机号弹框 -->
      <el-dialog
        title="修改手机号"
        :visible.sync="dialogPhone"
        width="30%"
        @close="resetForm('phoneForm')"
      >
        <el-form ref="phoneForm" :model="phoneForm" label-width="120px">
          <el-form-item label="旧手机号：">
            <el-input v-model="phoneForm.name" placeholder="请输入旧手机号"></el-input>
          </el-form-item>
          <el-form-item label="新手机号：">
            <el-input v-model="phoneForm.name" placeholder="请输入新手机号"></el-input>
          </el-form-item>
          <el-form-item class="code" label="验证码：">
            <el-input v-model="phoneForm.name" placeholder="请输入验证码"></el-input>
            <el-button type="primary">发送验证码</el-button>
          </el-form-item>
          <el-form-item class="bot">
            <el-button type="primary" @click="submitPhone">确认</el-button>
            <el-button @click="dialogPhone = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import http from "../api/login";

export default {
  name: "record",
  data() {
    var checkOldPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入旧密码"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入新密码"));
      } else if (value.toString().length < 6 || value.toString().length > 18) {
        callback(new Error("密码长度为6 - 18个字符"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      dialogPhone: false,
      phoneForm: {
        name: ""
      },
      ruleForm: {
        oldPass: "",
        pass: "",
        checkPass: ""
      },
      rules: {
        oldPass: [{ validator: checkOldPass, trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  components: {
    HeadCom,
    FooterCom
  },
  methods: {
    /* 弹框表单清空 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onSubmit(formName) {
      // this.dialogVisible = false;
      this.$refs[formName].validate(valid => {
        console.log(valid, "valid");
        if (valid) {
          http
            .updatePassword({
              oldPassword: this.ruleForm.oldPass,
              newPassword: this.ruleForm.pass
            })
            .then(data => {
              if (data.data.code == "200" || data.data.success == true) {
                this.$message.success({
                  duration: 1000,
                  message: "密码修改成功！"
                });
                this.dialogVisible = false;
                setTimeout(() => {
                  this.$router.push({
                    path: "/"
                  });
                }, 1000);
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message
                });
              }
            })
            .catch(error => {
              this.$message.error({
                duration: 1000,
                message: "请求失败，请联系管理员！"
              });
            });
        }
      });
    },
    submitPhone() {
      this.dialogPhone = false;
    },
    // 更换手机号
    updatePhone() {
      this.dialogPhone = true;
    }
  }
};
</script>
<style lang="less" scoped>
.bot {
  /deep/.el-form-item__content {
    margin-left: 0 !important;
    text-align: center;
  }
}
/deep/.el-input {
  width: 80%;
}
.code {
  /deep/.el-form-item__content {
    width: 62%;
    display: flex;
  }
  /deep/.el-input {
    margin-right: 10px;
  }
}
.cont {
  border-radius: 6px;
  width: 100%;
  margin: 20px 0;
  background: #ffffff;
}
.title {
  font-size: 18px;
  line-height: 60px;
  border-bottom: 1px solid #ddd;
  padding: 0 20px;
  font-weight: normal;
}
.set-wrap {
  padding: 20px;
}
.line {
  padding: 20px;
  border-bottom: 1px solid #ddd;
  &:last-child {
    border-bottom: none;
  }
  .left {
    background: url("../assets/images/login.png") no-repeat left;
    background-size: 30px 30px;
    padding-left: 46px;
    color: #333;
    .tit {
      font-size: 18px;
      line-height: 30px;
    }
    .tips {
      color: #999;
      font-size: 14px;
    }
  }
  .phone {
    background: url("../assets/images/phone.png") no-repeat left;
  }
  .real {
    background: url("../assets/images/real.png") no-repeat left;
    background-size: 36px 36px;
  }
}
</style>
